import Vue from 'vue'

import s_cabecalho from './sections/cabecalho.vue';
import s_rodape from './sections/rodape.vue';
import interna from './sections/interna.vue';

Vue.component('interna', interna);
Vue.component('s-cabecalho', s_cabecalho);
Vue.component('s-rodape', s_rodape);
